import { Box } from '@chakra-ui/react';
import { FC, useEffect, useState } from 'react';
import { TimerState } from '../../../../hooks/useTimer';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

type Props = {
  timerDuration: number;
  timerState: TimerState;
};
const RemainingTimeTimer: FC<Props> = ({ timerDuration, timerState }) => {
  const [duration, setDutation] = useState(0);
  const getMinSecFormat = (remainingTime: number) => {
    const minutes = Math.floor(remainingTime / 60);
    const seconds = Math.floor(remainingTime % 60);
    return `${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`;
  };
  useEffect(() => {
    setDutation(timerDuration);
  }, [timerDuration !== 0]);

  return (
    <>
      {timerState !== 'displayTimer' ? null : (
        <Box color={'white'}>
          <CountdownCircleTimer
            isPlaying
            duration={duration} // 最初に設定した時間から自動的にカウントダウンされるため、毎秒渡さない
            colors="#4E9F3D" // circle border color - green
            size={75}
            strokeWidth={5}
          >
            {({ remainingTime }) => getMinSecFormat(remainingTime)}
          </CountdownCircleTimer>
        </Box>
      )}
    </>
  );
};
export default RemainingTimeTimer;
